import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { DeviceDetailActionTypes, DeviceDetailActions } from '../actions/device-detail.actions';
import {DeviceMgtService} from '../../../services/device-mgt.service';
import {Store} from '@ngrx/store';
import * as featureActions from '../../index';


@Injectable()
export class DeviceDetailEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceMgtService = inject(DeviceMgtService);

  constructor() {}

  GetDeviceDetails$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceDetailActionTypes.GetDeviceDetails),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actions, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        dcode: actions.payload
      };
      return this.deviceMgtService.ReadDeviceDetails(params).pipe(
        switchMap((res) => {
          if (res.result && res.msg.body) {
            const data = res.msg.body;
            const dcodeList = (Array.isArray(data.UsedLicense)) ? data.UsedLicense.map(item => item.dcode) : [];
            dcodeList.push(actions.payload);
            return [new featureActions.LoadDeviceDetails(res.msg.body),
              new featureActions.GetDevices(dcodeList)];
          } else {
            return of(new featureActions.GetDeviceDetailsFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return of(new featureActions.GetDeviceDetailsFail());
        })
      );
    })
  ));



}
